import { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { Button } from 'components/UI/Button/Button';
import { yupResolver } from '@hookform/resolvers/yup';
import { subscriptionFormSchema } from 'utils/form-validation-schema';

import './SubscriptionForm.scss';

export const SubscriptionForm = (props) => {
  const { onSuccessHandler, onResponseErrorHandler, buttonText } = props;
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(subscriptionFormSchema),
  });

  const onSubmit = (data) => {
    const payload = {
      GuestEmail: data.emailAddress,
      FirstName: data.firstName,
      LastName: data.lastName,
    };

    const apiUrl = '/controller/Account/SaveSubscribeRegisterInformation';

    setIsLoading(true);

    axios.post(apiUrl, payload).then((response) => {
      if (response?.data.RegisterErrorMessage) {
        onResponseErrorHandler(true);
        setIsLoading(false);
      } else {
        onResponseErrorHandler(false);
        onSuccessHandler(true);
        setIsLoading(false);
      }
    });
  };

  const firstNameErrorClass = errors.firstName ? 'input-error' : '';
  const lastNameErrorClass = errors.lastName ? 'input-error' : '';
  const emailErrorClass = errors.emailAddress ? 'input-error' : '';
  const allInputsErrorred = errors.firstName && errors.lastName && errors.emailAddress;

  return (
    <form
      className="subscription-form"
      onSubmit={handleSubmit(onSubmit)}
      data-testid="subscription-form"
    >
      <div
        className={`form__input-errors ${allInputsErrorred ? 'all-errored' : ''}`}
        data-testid="form-errors"
      >
        {errors.firstName && <span>{errors?.firstName?.message}</span>}
        {errors.lastName && <span>{errors?.lastName?.message}</span>}
        {errors.emailAddress && <span>{errors?.emailAddress?.message}</span>}
      </div>

      <div className="subscription-form__controls">
        <input
          name="firstName"
          placeholder="First name"
          className={`subscription-form__input ${firstNameErrorClass}`}
          data-testid="first-name"
          {...register('firstName')}
        />
        <input
          name="lastName"
          placeholder="Last name"
          className={`subscription-form__input ${lastNameErrorClass}`}
          data-testid="last-name"
          {...register('lastName')}
        />
        <input
          name="emailAddress"
          placeholder="Email address"
          className={`subscription-form__input ${emailErrorClass}`}
          data-testid="email-address"
          {...register('emailAddress')}
        />

        <Button
          type="submit"
          extendClass="subscription-form__button"
          disabled={!isDirty || !isValid || isLoading}
        >
          {buttonText}
        </Button>
      </div>
    </form>
  );
};

SubscriptionForm.propTypes = {
  onSuccessHandler: PropTypes.func.isRequired,
  onResponseErrorHandler: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
};
